(() => {
  const dispatchText = 'Versand in der Regel innerhalb von 2 Versandwerktagen nach bestätigtem Zahlungseingang.';
  let cart = null;
  let cartRequest = 0;
  let cartStarted = false;
  const cartQuantity = (variantId, fallback = 0) => cart
    ? cart.items.reduce((total, item) => total + (String(item.variant_id) === String(variantId) ? item.quantity : 0), 0)
    : fallback;
  const refreshCart = async () => {
    const element = document.querySelector('gg-stock-delivery');
    if (!element) return;
    const requestId = ++cartRequest;
    try {
      const response = await fetch(element.dataset.cartUrl, { headers: { Accept: 'application/json' } });
      if (!response.ok) return;
      const result = await response.json();
      if (requestId !== cartRequest || !Array.isArray(result.items)) return;
      cart = result;
      document.querySelectorAll('gg-stock-delivery').forEach(status => status.render());
    } catch {}
  };

  class GGStockDelivery extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      this.variants = this.readVariants(this);
      this.variantId = this.dataset.variantId;
      this.scope = this.closest('.product-information, quick-add-dialog') || this.closest('.shopify-section') || this.parentElement;
      this.section = this.closest('.shopify-section') || this.scope;
      const options = { signal: this.controller.signal };
      this.scope.addEventListener('variant:selected', this.onVariant, options);
      this.scope.addEventListener('variant:update', this.onVariant, options);
      this.scope.addEventListener('input', this.onQuantity, options);
      this.scope.addEventListener('change', this.onQuantity, options);
      this.scope.addEventListener('quantity-selector:update', this.onQuantity, options);
      this.initializeQuantity();
      this.render();
      if (!cartStarted) {
        cartStarted = true;
        refreshCart();
      }
    }

    disconnectedCallback() {
      this.controller?.abort();
    }

    readVariants(element) {
      try { return JSON.parse(element.querySelector('[data-gg-stock-variants]').textContent); }
      catch { return []; }
    }

    initializeQuantity() {
      const input = this.scope.querySelector('product-form-component input[name="quantity"]');
      if (!input) return;
      const minimum = Math.max(1, 5 - cartQuantity(this.variantId));
      input.min = String(minimum);
      if (Number(input.value) < minimum) input.value = String(minimum);
    }

    onQuantity = (event) => {
      if (event.type === 'quantity-selector:update' || event.target.matches?.('input[name="quantity"]')) this.render();
    };

    onVariant = (event) => {
      const data = event.detail?.data;
      const productId = data?.newProduct?.id || data?.productId || event.target.dataset?.productId;
      if (productId && String(productId) !== this.dataset.productId && !data?.newProduct) return;
      const incoming = data?.html?.querySelector(`gg-stock-delivery[data-product-id="${productId || this.dataset.productId}"]`);
      if (incoming) {
        this.variants = this.readVariants(incoming);
        this.dataset.productId = incoming.dataset.productId;
        this.dataset.unit = incoming.dataset.unit;
      }
      const variantId = event.detail?.resource?.id;
      if (event.type === 'variant:selected' && !this.variants.some(item => String(item.id) === String(variantId))) {
        this.updating = true;
        this.render();
        return;
      }
      this.updating = false;
      this.variantId = variantId ? String(variantId) : '';
      this.dataset.variantId = this.variantId;
      this.initializeQuantity();
      this.render();
      queueMicrotask(() => { if (this.isConnected) this.render(); });
    };

    getState() {
      const variant = this.variants.find(item => String(item.id) === this.variantId);
      const input = this.scope.querySelector('product-form-component input[name="quantity"]');
      const quantity = input ? Number(input.value) : 5;
      const inCart = cartQuantity(this.variantId, variant?.cartQuantity || 0);
      let status = 'Verfügbarkeit auf Anfrage';
      let note = 'Bitte fragen Sie die Verfügbarkeit und den Versandtermin an.';
      let orderable = false;
      if (variant?.managed) {
        if (variant.quantity <= 0) {
          status = 'Aktuell nicht auf Lager';
          note = 'Verfügbarkeit und Versandtermin erhalten Sie auf Anfrage.';
        } else if (variant.quantity < 5) {
          status = 'Restbestand vorhanden';
          note = `Die Mindestbestellmenge beträgt 5 ${this.dataset.unit} pro Design. Bitte fragen Sie den Restbestand an.`;
        } else if (quantity + inCart > variant.quantity) {
          status = 'Auf Lager';
          note = `Die gewünschte Gesamtmenge einschließlich Warenkorb übersteigt den Lagerbestand von ${variant.quantity} ${this.dataset.unit}. Bitte fragen Sie diese Menge an.`;
        } else if (!Number.isInteger(quantity) || quantity < 1 || quantity + inCart < 5) {
          status = 'Auf Lager';
          note = `Die Mindestbestellmenge beträgt 5 ${this.dataset.unit} pro Design einschließlich Warenkorb.`;
        } else if (variant.available) {
          status = 'Auf Lager';
          note = dispatchText;
          orderable = true;
        }
      }
      if (this.updating) {
        status = 'Verfügbarkeit wird aktualisiert';
        note = 'Bitte warten Sie einen Moment.';
        orderable = false;
      }
      return { variant, quantity, inCart, input, status, note, orderable };
    }

    canSubmit() {
      this.render();
      return this.dataset.orderable === 'true';
    }

    render() {
      if (!this.scope) return;
      const state = this.getState();
      this.dataset.orderable = String(state.orderable);
      const status = this.querySelector('[data-gg-stock-status]');
      const note = this.querySelector('[data-gg-stock-note]');
      const low = this.querySelector('[data-gg-stock-low]');
      const contact = this.querySelector('[data-gg-stock-contact]');
      if (status.textContent !== state.status) status.textContent = state.status;
      if (note.textContent !== state.note) note.textContent = state.note;
      low.hidden = this.updating || !(state.variant?.managed && state.variant.quantity > 0 && state.variant.quantity < 50);
      if (!low.hidden) low.textContent = `Geringer Bestand: noch ${state.variant.quantity} ${this.dataset.unit}.`;
      contact.hidden = state.orderable || this.updating;
      const form = this.closest('product-form-component');
      if (form) {
        form.querySelectorAll('button[type="submit"]').forEach(button => { button.disabled = !state.orderable; });
        const accelerated = form.querySelector('.shopify-payment-button');
        if (accelerated) accelerated.hidden = !state.orderable;
      }
      this.section.querySelectorAll('sticky-add-to-cart button[ref="addToCartButton"]').forEach(button => {
        button.disabled = !state.orderable;
      });
      const registration = this.scope.querySelector('[data-gg-registration-box] .gg-sperre__btn');
      const stickyRegistration = document.querySelector(`[data-gg-sticky-registration][data-product-id="${this.dataset.productId}"] a`);
      [registration, stickyRegistration].filter(Boolean).forEach(link => {
        if (!link.dataset.ggOriginalHref) {
          link.dataset.ggOriginalHref = link.getAttribute('href');
          link.dataset.ggOriginalText = link.textContent;
        }
        const href = state.orderable || this.updating ? link.dataset.ggOriginalHref : this.dataset.contactUrl;
        const label = state.orderable || this.updating ? link.dataset.ggOriginalText : 'Verfügbarkeit & Menge anfragen →';
        if (link.getAttribute('href') !== href) link.setAttribute('href', href);
        if (link.textContent !== label) link.textContent = label;
      });
    }
  }

  if (!customElements.get('gg-stock-delivery')) customElements.define('gg-stock-delivery', GGStockDelivery);
  document.addEventListener('cart:update', refreshCart);
  document.addEventListener('cart:updated', refreshCart);
  document.addEventListener('product-ajax:added', refreshCart);
  document.addEventListener('cart:error', refreshCart);
})();
